import { VerifyCodeStepFormFieldsEnum, yupLanding } from "@ryde/utils-landings";

export const yupVerifyCodeLandingValidationSchema = {
  [VerifyCodeStepFormFieldsEnum.VerificationCode]: yupLanding
    .string()
    .required(),
};
